import axios from "./axios";

class AuthService {
  loginWithMobile = async (mobile) => {
    try {
      const response = await axios.post(
        "/login/login_without_pass",
        { mobile, login_via: "WEB" },
        {
          headers: {
            "X-App-Version": "1.0.0",
          },
        }
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      // Safe fallback for nested error messages
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  verifyOtp = async (otp, token) => {
    try {
      const response = await axios.post("/login/verify_otp", { otp, token });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  signupSendOtp = async (name, email, mobile, lat, long) => {
    try {
      const response = await axios.post("/signup-v2/send_otp", {
        name,
        email,
        mobile,
        lat,
        long,
        channel: "WEB",
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  signupVerifyOtp = async (otp, token) => {
    try {
      const response = await axios.post("/signup-v2/verify_otp", {
        otp,
        token,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}

export default new AuthService();
